<template>
  <div class="page">
    <div class="seiten-kopf">
      <router-link to="/einkaufsliste" class="seiten-kopf-zurueck" aria-label="Zurück">
        <font-awesome-icon icon="fa-solid fa-arrow-left" />
      </router-link>
      <h1>Zutaten hinzufügen</h1>
    </div>

    <form class="zutat-form" @submit.prevent>
      <label for="neue-zutat-name">Zutat</label>
      <div class="input-field">
        <input id="neue-zutat-name" v-model="NeueZutat.Name" type="text" placeholder="Zutat" />
      </div>

      <label for="neue-zutat-menge">Menge</label>
      <div class="input-field">
        <input id="neue-zutat-menge" v-model.number="NeueZutat.Menge" type="number" min="0" step="any" placeholder="Menge" />
      </div>

      <label for="neue-zutat-einheit">Einheit</label>
      <div class="input-field">
        <select id="neue-zutat-einheit" v-model="NeueZutat.Einheit">
          <option value="Gramm">Gramm</option>
          <option value="Kg">Kg</option>
          <option value="ml">ml</option>
          <option value="Liter">Liter</option>
          <option value="Volumen">Volumen</option>
          <option value="Stück">Stück</option>
          <option value="Flasche">Flasche</option>
          <option value="Packung">Packung</option>
          <option value="EL">EL</option>
          <option value="Netz">Netz</option>
        </select>
      </div>

      <label for="neue-zutat-kategorie">Kategorie</label>
      <div class="input-field">
        <select id="neue-zutat-kategorie" v-model="NeueZutat.KategorieId">
          <option v-for="Kategorie in Kategorien" :key="Kategorie.Id" :value="Kategorie.Id">{{ Kategorie.Name }}</option>
        </select>
      </div>

      <label class="filter-toggle-zeile">
        <input v-model="NeueZutat.Eingefroren" type="checkbox" />
        🧊 Diese Zutat ist eingefroren
      </label>

      <label>Foto</label>
      <BildAuswahl v-model="NeuesBild" />

      <p v-if="Status" class="hint-message success">{{ Status }}</p>
      <p v-if="Fehlermeldung" class="error-message">{{ Fehlermeldung }}</p>

      <div class="button-row">
        <button type="button" class="btn btn-primary" @click="Hinzufuegen">Hinzufügen</button>
        <router-link to="/einkaufsliste" class="btn btn-secondary">Zurück</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { ZutatHinzufuegen, ZutatBildSpeichern, Kategorien, KategorienLaden } from '../composables/useZutaten'
import BildAuswahl from '../components/BildAuswahl.vue'

export default {
  name: 'ZutatenHinzufuegenView',
  components: { BildAuswahl },
  data() {
    return {
      Kategorien,
      NeueZutat: { Name: '', Menge: null, Einheit: 'Gramm', KategorieId: null, Eingefroren: false },
      NeuesBild: undefined,
      Status: '',
      Fehlermeldung: ''
    }
  },
  async created() {
    await KategorienLaden()
    if (!this.NeueZutat.KategorieId && Kategorien.length > 0) {
      this.NeueZutat.KategorieId = Kategorien[0].Id
    }
  },
  methods: {
    async Hinzufuegen() {
      this.Fehlermeldung = ''
      if (!this.NeueZutat.Name) {
        return
      }
      try {
        const Neu = await ZutatHinzufuegen({ ...this.NeueZutat })
        if (typeof this.NeuesBild === 'string') {
          try {
            await ZutatBildSpeichern(Neu.Id, this.NeuesBild)
          } catch {
            this.Fehlermeldung = 'Zutat gespeichert, aber das Foto konnte nicht hochgeladen werden.'
          }
        }
        this.Status = `"${this.NeueZutat.Name}" hinzugefügt.`
        this.NeueZutat = { Name: '', Menge: null, Einheit: 'Gramm', KategorieId: Kategorien[0] ? Kategorien[0].Id : null, Eingefroren: false }
        this.NeuesBild = undefined
        setTimeout(() => { this.Status = '' }, 2000)
      } catch (Fehler) {
        this.Fehlermeldung = Fehler.message
      }
    }
  }
}
</script>

<style scoped>
.zutat-form {
  display: flex;
  flex-direction: column;
  max-width: 320px;
  margin-top: 16px;
}

.zutat-form label {
  margin-top: 12px;
  margin-bottom: 4px;
  font-size: 0.9rem;
}
</style>
